"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomComponent = void 0;
const react_1 = __importDefault(require("react"));
const ReactiveComponent_1 = __importDefault(require("@usereactify/search-internals/lib/components/basic/ReactiveComponent"));
const CustomComponent = (props) => {
    return react_1.default.createElement(ReactiveComponent_1.default, Object.assign({}, props));
};
exports.CustomComponent = CustomComponent;
//# sourceMappingURL=CustomComponent.js.map